export default __webpack_public_path__ + "static/media/university-of-richmond.c1e3d0d8.png";